module.exports = __webpack_public_path__ + "img/default-image.440b9b23.jpg";